module.exports = __webpack_public_path__ + "static/img/verificatioin_success.1259e17.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/verificatioin_success.svg
// module id = BxkF
// module chunks = 4